require('./brokerOrdersAndMovementsNewView.scss');
const PropTypes = require('prop-types');
// @ vendors
const React = require('react');
// @ commons
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const StocksContractDropdown = require('components/broker/commons/stocksContractDropdown/stocksContractDropdown');
const InformativeItem = require('components/commons/informativeItem/informativeItem');
const OKSelect = require('components/commons/OKSelect/OKSelect');
// @ helpers
const { formatText } = require('core/i18n').i18n;
const { formatAmountObject, formatAmount } = require('utilities/currencyHelper');
const { toFirstUppercase, capitalize } = require('utilities/stringHelper');
const DateHelper = require('utilities/dateHelper');
// @ constants
const {
  BROKER_JOINT_CONTRACTS_CRYPTO,
  BROKER_JOINT_CONTRACTS_FUND,
  BROKER_JOINT_CONTRACTS_FUTURES,
  BROKER_JOINT_CONTRACTS_PLAN,
  BROKER_JOINT_CONTRACTS_VALUE,
  BROKER_ORDERS_AND_MOVEMENTS_FUND_MOVEMENTS_CONSOLIDATED,
  BROKER_ORDERS_AND_MOVEMENTS_FUND_MOVEMENTS_NULLED,
  BROKER_ORDERS_AND_MOVEMENTS_FUND_MOVEMENTS_PENDING,
  BROKER_ORDERS_AND_MOVEMENTS_PLAN_OTHER,
  BROKER_ORDERS_AND_MOVEMENTS_PLAN_PENDING_MOVES,
  BROKER_ORDERS_AND_MOVEMENTS_PLAN_PERIODIC,
  BROKER_STOCKS_CONTRACT_DROPDOWN_GROUPED_CONTRACTS_MODIFIER,
  DATE_FORMAT_ES,
  HYPHEN,
  TYPE_ETFS,
  TYPE_FUNDS,
  TYPE_FUTURES,
  TYPE_PLANS,
  TYPE_STOCKS,
  TYPE_WARRANTS,
} = require('constants/index');

class BrokerOrdersAndMovementsNewView extends React.Component {
  constructor(props) {
    super(props);

    this.handleStockContractChange = this.handleStockContractChange.bind(this);
    this.handleOptionChange = this.handleOptionChange.bind(this);
  }

  componentDidMount() {
    this.setDefaultSelectedContract();
  }

  getContractIdByNumber(contractNumber) {
    const contract = this.props.immJointContracts.get('byId').find(contract => {
      return contract.get('walletNumber').endsWith(contractNumber);
    });

    return contract ? contract.get('id') : '';
  }

  getUniqueProductContractId(type) {
    let contractId;
    switch (type) {
      case TYPE_STOCKS:
      case TYPE_ETFS:
      case TYPE_WARRANTS:
        contractId = this.findContractId(BROKER_JOINT_CONTRACTS_VALUE);
        break;
      case TYPE_FUNDS:
        contractId = this.findContractId(BROKER_JOINT_CONTRACTS_FUND);
        break;
      case TYPE_PLANS:
        contractId = this.findContractId(BROKER_JOINT_CONTRACTS_PLAN);
        break;
      case TYPE_FUTURES:
        contractId = this.findContractId(BROKER_JOINT_CONTRACTS_FUTURES);
        break;
      default:
        contractId = '';
    }

    return contractId;
  }

  setDefaultSelectedContract() {
    const { contractList } = this.props;
    let contractId;
    const values = contractList.get('values').toJS();
    const funds = contractList.get('funds').toJS();
    const plans = contractList.get('plans').toJS();
    const crypto = contractList.get('crypto').toJS();
    const isUniqueContract = values.length + funds.length + plans.length + crypto.length === 1;
    if (isUniqueContract) {
      if (values.length === 1) {
        contractId = values[0].id;
      }
      if (funds.length === 1) {
        contractId = funds[0].id;
      }
      if (plans.length === 1) {
        contractId = plans[0].id;
      }
      if (crypto.length === 1) {
        contractId = crypto[0].id;
      }
    }

    this.handleStockContractChange(contractId);
  }

  buildContractInformation() {
    const { immContract } = this.props;

    const firstTitularType = immContract.get('firstTitularType');
    const intervenorType = toFirstUppercase(
      formatText(`interventionTypes-${capitalize(firstTitularType ? firstTitularType.trim() : '')}`)
    );
    const isCrypto = immContract.get('type') === BROKER_JOINT_CONTRACTS_CRYPTO;

    let content;
    let associatedAccountContent;

    if (immContract.get('type') === BROKER_JOINT_CONTRACTS_VALUE || isCrypto) {
      const { amount, currencySymbol } = formatAmountObject(
        immContract.getIn(['associatedAccount', 'balance'], 0)
      );
      const balance = formatText('broker-ordersAndMovementsContractInformationAmount', [
        amount,
        currencySymbol,
      ]);
      const intervenor = formatText(
        'broker-ordersAndMovementsContractInformationInterventionType',
        [intervenorType]
      );

      if (immContract.getIn(['associatedAccount', 'number'])) {
        associatedAccountContent = (
          <InformativeItem
            title={formatText('broker-ordersAndMovementsContractInformationAccount').toUpperCase()}
            primaryText={immContract.getIn(['associatedAccount', 'number'])}
            secondaryText={amount ? balance : ''}
          />
        );
      } else {
        associatedAccountContent = (
          <InformativeItem
            title={formatText('broker-ordersAndMovementsContractInformationAccount').toUpperCase()}
            primaryText={HYPHEN}
          />
        );
      }
      content = (
        <div className="row no-gutter">
          <div className="col-xs-5">{associatedAccountContent}</div>
          <div className="col-xs-7">
            <InformativeItem
              title={formatText(
                'broker-ordersAndMovementsContractInformationTitular'
              ).toUpperCase()}
              primaryText={isCrypto ? immContract.get('firstHolder') : immContract.get('firstTitular')}
              secondaryText={!isCrypto && intervenor}
            />
          </div>
        </div>
      );
    } else {
      const assetValue = formatAmountObject(immContract.get('assetValue'));
      const dateLabel = DateHelper.buildFormattedDate(
        immContract.get('lastSettlementDate'),
        DATE_FORMAT_ES
      );
      const amount = `${formatAmount(assetValue.amount, undefined, 3) || HYPHEN} ${
        assetValue.currencySymbol
      } (${dateLabel})`;

      content = (
        <div className="row">
          <div className="col-xs-3 broker-orders-and-movements-consult__column">
            <InformativeItem
              title={formatText(
                'broker-ordersAndMovementsContractInformationAccount'
              ).toUpperCase()}
              primaryText={immContract.getIn(['associatedAccount', 'number'])}
            />
          </div>
          <div className="col-xs-3 broker-orders-and-movements-consult__mid-column-right">
            <InformativeItem
              title={formatText(
                'broker-ordersAndMovementsContractInformationTitular'
              ).toUpperCase()}
              primaryText={immContract.get('firstTitular')}
            />
          </div>
          <div className="col-xs-3 broker-orders-and-movements-consult__mid-column">
            <InformativeItem
              title={formatText('broker-ordersAndMovementsContractInformationShares').toUpperCase()}
              primaryText={formatAmount(immContract.get('shares'), undefined, 5)}
            />
          </div>
          <div className="col-xs-3 broker-orders-and-movements-consult__column">
            <InformativeItem
              title={formatText(
                'broker-ordersAndMovementsContractInformationLastValue'
              ).toUpperCase()}
              primaryText={amount}
            />
          </div>
        </div>
      );
    }

    return (
      <section>
        <div className="broker-orders-and-movements-consult__separator" />
        <section className="broker-orders-and-movements-consult__contract-info">{content}</section>
      </section>
    );
  }

  findContractId(productType) {
    const contracts = this.props.immJointContracts.get('byId').filter(contract => {
      return contract.get('type') === productType;
    });

    return contracts.size === 1 ? contracts.first().get('id') : '';
  }

  handleOptionChange(selectedOption) {
    this.props.setSelectedOption(selectedOption);
  }

  handleStockContractChange(contractId) {
    this.props.setSelectedOption(null);
    this.props.setSelectedContract(contractId);
  }

  buildDropdownOptions() {
    const { contractList } = this.props;
    const values = contractList.get('values').toJS();
    const funds = contractList.get('funds').toJS();
    const plans = contractList.get('plans').toJS();
    const crypto = contractList.get('crypto').toJS();
    const buildOptions = (list, label) => {
      let newOptions = Array.from(list);
      newOptions.unshift({ disabled: true, label });
      newOptions = newOptions.map(item => {
        return { ...item, showHyphen: true };
      });
      return newOptions;
    };

    let options = [];
    if (values.length > 0) {
      options.push(...buildOptions(values, 'broker-ordersAndMovementsConsultLabelValue'));
    }
    if (funds.length > 0) {
      options.push(...buildOptions(funds, 'broker-ordersAndMovementsConsultLabelFund'));
    }
    if (plans.length > 0) {
      options.push(...buildOptions(plans, 'broker-ordersAndMovementsConsultLabelPlan'));
    }
    if (crypto.length > 0) {
      options.push(...buildOptions(crypto, 'broker-ordersAndMovementsConsultLabelCrypto'));
    }

    return options;
  }

  render() {
    const { selectedContract, immContract, selectedOption, contractList, immFeatureFlag } =
      this.props;
    const ffContribution = immFeatureFlag.get('wealth_funds_periodic_contributions');
    const title = formatText('broker-ordersAndMovementsConsultTitle');
    const newDropdownOptions = this.buildDropdownOptions();

    const stocksContractPlaceholder = formatText('broker-ordersAndMovementsConsultPlaceholder');
    const values = contractList.get('values').toJS();
    const funds = contractList.get('funds').toJS();
    const plans = contractList.get('plans').toJS();
    const crypto = contractList.get('crypto').toJS();

    const isUniqueContract = values.length + funds.length + plans.length + crypto.length === 1;
    let selector, contractInfo;

    if (immContract) {
      if (immContract.get('type') !== BROKER_JOINT_CONTRACTS_FUTURES) {
        contractInfo = this.buildContractInformation();
      }

      if (immContract.get('type') === BROKER_JOINT_CONTRACTS_FUND && !ffContribution) {
        const options = [
          {
            label: formatText('broker-ordersAndMovementsConsultSelectOptionPending'),
            value: BROKER_ORDERS_AND_MOVEMENTS_FUND_MOVEMENTS_PENDING,
          },
          {
            label: formatText('broker-ordersAndMovementsConsultSelectOptionConsolidated'),
            value: BROKER_ORDERS_AND_MOVEMENTS_FUND_MOVEMENTS_CONSOLIDATED,
          },
          {
            label: formatText('broker-ordersAndMovementsConsultSelectOptionCancelled'),
            value: BROKER_ORDERS_AND_MOVEMENTS_FUND_MOVEMENTS_NULLED,
          },
        ];
        const label = formatText('broker-ordersAndMovementsConsultSelectState');

        selector = (
          <div className="broker-orders-and-movements-consult__state-selector">
            <OKSelect
              name="broker-orders-and-movements-consult-state"
              onChange={this.handleOptionChange}
              value={selectedOption}
              label={label}
              options={options}
              searchable={false}
              clearable={false}
            />
          </div>
        );
      } else if (immContract.get('type') === BROKER_JOINT_CONTRACTS_PLAN) {
        const options = [
          {
            label: formatText('broker-ordersAndMovementsConsultSelectOptionPeriodic'),
            value: BROKER_ORDERS_AND_MOVEMENTS_PLAN_PERIODIC,
          },
          {
            label: formatText('broker-ordersAndMovementsConsultSelectOptionOther'),
            value: BROKER_ORDERS_AND_MOVEMENTS_PLAN_OTHER,
          },
          {
            label: formatText('broker-ordersAndMovementsConsultSelectOptionPendingMoves'),
            value: BROKER_ORDERS_AND_MOVEMENTS_PLAN_PENDING_MOVES,
          },
        ];
        const label = formatText('broker-ordersAndMovementsConsultSelectOperationType');

        selector = (
          <div className="broker-orders-and-movements-consult__operation-type-selector">
            <OKSelect
              name="broker-orders-and-movements-consult-operation-type"
              onChange={this.handleOptionChange}
              value={selectedOption}
              label={label}
              options={options}
              searchable={false}
              clearable={false}
            />
          </div>
        );
      }
    }

    return (
      <OKSectionBox title={title} className="broker-orders-and-movements-consult">
        <div className="row">
          <div className="col-xs-8">
            <StocksContractDropdown
              label="broker-ordersAndMovementsConsultLabel"
              onStockContractChange={this.handleStockContractChange}
              options={newDropdownOptions}
              selectedValue={selectedContract}
              placeholder={stocksContractPlaceholder}
              showAdditionalInfo={false}
              modifier={BROKER_STOCKS_CONTRACT_DROPDOWN_GROUPED_CONTRACTS_MODIFIER}
              disabled={isUniqueContract}
              startResultsScrollAtTop={true}
            />
          </div>
          <div className="col-xs-4">{selector}</div>
        </div>
        {contractInfo}
      </OKSectionBox>
    );
  }
}

BrokerOrdersAndMovementsNewView.propTypes = {
  immJointContracts: PropTypes.object.isRequired,
  selectedContract: PropTypes.string,
  selectedOption: PropTypes.object,
  immContract: PropTypes.object,
  immOrdersAndMovements: PropTypes.object,
  setSelectedContract: PropTypes.func.isRequired,
  setSelectedOption: PropTypes.func.isRequired,
  planId: PropTypes.string,
  immFeatureFlag: PropTypes.func.isRequired,
};

module.exports = BrokerOrdersAndMovementsNewView;
